import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { sb } from "@/lib/sb";

export const Route = createFileRoute("/_authenticated/dashboard/pages")({
  component: PagesSeo,
});

type Row = {
  page_slug: string;
  meta_title: string | null;
  meta_description: string | null;
  updated_at: string;
};

function PagesSeo() {
  const [rows, setRows] = useState<Row[]>([]);

  const load = () =>
    sb.from("page_seo")
      .select("*")
      .order("page_slug")
      .then(({ data }: { data: Row[] | null }) => setRows(data ?? []));
  useEffect(() => {
    load();
  }, []);

  const save = async (r: Row) => {
    const { error } = await sb
      .from("page_seo")
      .update({ meta_title: r.meta_title, meta_description: r.meta_description })
      .eq("page_slug", r.page_slug);
    if (error) toast.error(error.message);
    else toast.success("Saved");
  };

  return (
    <div className="space-y-4">
      <h1 className="font-display text-2xl font-bold text-ink">Pages SEO</h1>
      {rows.map((r) => (
        <div key={r.page_slug} className="bg-card border border-border rounded-xl p-4 space-y-2">
          <div className="flex items-center justify-between">
            <p className="font-display font-semibold">
              /{r.page_slug === "home" ? "" : r.page_slug}
            </p>
            <p className="text-xs text-muted-foreground">
              Updated {new Date(r.updated_at).toLocaleDateString()}
            </p>
          </div>
          <input
            value={r.meta_title ?? ""}
            placeholder="Meta title (<60 chars)"
            maxLength={70}
            onChange={(e) =>
              setRows((p) =>
                p.map((x) => (x.page_slug === r.page_slug ? { ...x, meta_title: e.target.value } : x)),
              )
            }
            className="w-full px-3 py-2 rounded-lg bg-background border border-border text-sm"
          />
          <textarea
            rows={2}
            value={r.meta_description ?? ""}
            placeholder="Meta description (<160 chars)"
            maxLength={180}
            onChange={(e) =>
              setRows((p) =>
                p.map((x) =>
                  x.page_slug === r.page_slug ? { ...x, meta_description: e.target.value } : x,
                ),
              )
            }
            className="w-full px-3 py-2 rounded-lg bg-background border border-border text-sm resize-none"
          />
          <button
            onClick={() => save(r)}
            className="px-4 py-1.5 rounded-lg bg-brand hover:bg-brand-hover text-primary-foreground text-sm font-semibold"
          >
            Save
          </button>
        </div>
      ))}
    </div>
  );
}
